export function setLoading (state, value) {
    state.loading = value;
}

export function setMessageLoading (state, value) {
    state.message_loading = value;
}
export function setFile(state, value) {
    state.file = value;
}



// WEBPACK FOOTER //
// ./src/modules/import-ideal-balances/mutations.js